import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// In-memory de-dupe so a single SPA navigation can't double-fire from
// React StrictMode dev double-mount or rapid query-string-only changes.
let lastSentKey = null;
let lastSentAt = 0;
const DEDUPE_WINDOW_MS = 1500;

/**
 * Fire-and-forget analytics ping. Never throws, never blocks UI.
 *
 * @param {Object} event
 * @param {string} event.path        SPA route (e.g. '/book')
 * @param {string} [event.eventType] page_view | service_view | booking_started | booking_completed
 * @param {string} [event.serviceId] when relevant (service_view, booking_*)
 */
export const track = (event) => {
  try {
    if (!event || !event.path) return;
    const eventType = event.eventType || 'page_view';
    const key = `${eventType}|${event.path}|${event.serviceId || ''}`;
    const now = Date.now();
    if (key === lastSentKey && (now - lastSentAt) < DEDUPE_WINDOW_MS) return;
    lastSentKey = key;
    lastSentAt = now;

    const token = sessionStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    axios.post(
      `${API_URL}/analytics/track`,
      {
        path: event.path,
        event_type: eventType,
        service_id: event.serviceId || null,
        // document.referrer is the cross-origin referrer (e.g. google.com)
        // when the user just landed; the backend uses it for source bucketing.
        referrer: typeof document !== 'undefined' ? document.referrer : '',
      },
      { headers, timeout: 4000 }
    ).catch(() => { /* swallow — tracking must never break the app */ });
  } catch (err) {
    // Defensive: never throw out of a tracking call.
  }
};

export default track;
